export * from './controls/controls';
export * from './duration/duration';
export * from './info/info';
export * from './play-button/play-button';
export * from './player-controls.component';
export * from './slides/slides.component';
